export enum widgetDtoTypes {
  PROPS = 'props',
  TOKEN = 'token',
}
